import { PageTitle } from "../layout/core"
import { ProfilePage } from "../framework/pages/profile-page"

export const ProfilePageWrapper = () => {
    return <>
        <PageTitle breadcrumbs={[]}>User Profile</PageTitle>
        <ProfilePage />
    </>
}
